import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 584px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 36px;
  text-align: center;
  color: ${({ theme }) => theme.pallette.dark.main};
  margin-bottom: 40px;
`;

export const Link = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.blue.link};
  cursor: pointer;
  transition: all 0.5s ease;
  margin-top: 20px;

  &:hover {
    opacity: 0.5;
  }
`;
